import {apiClient, type ApiResponse} from './client';

/** Which FIR(s) a controller (role: fir_atc) is assigned to. */
export interface IFirAssignment {
  id: string;
  fir_code: string;
}

export interface IUser {
  id: string;
  /** The pilot's airline (IATA), the prefix of their flight numbers. */
  airline?: string | null;
  email: string;
  first_name: string | null;
  last_name: string | null;
  full_name: string | null;
  username: string | null;
  role: string | null;
  fir_assignments?: IFirAssignment[] | null;
}

export interface ILoginData {
  access_token: string;
  refresh_token: string;
  user: IUser;
}

/** app: apis/auth.ts postLogin — the same endpoint the mobile login uses. */
export const postLogin = (
  email: string,
  password: string
): Promise<ApiResponse<ILoginData>> =>
  apiClient.post('/auth/login', {email, password});

export const getMe = (): Promise<ApiResponse<IUser>> =>
  apiClient.get('/api/v1/public/users/me', {timeout: 15000});

export const postLogout = (accessToken: string | null, refreshToken: string | null) => {
  if (!accessToken || !refreshToken) return Promise.resolve();
  return apiClient.post(
    '/auth/logout',
    {},
    {headers: {'X-Access-Token': accessToken, Authorization: `Bearer ${refreshToken}`}}
  );
};

export const ATC_ROLE = 'fir_atc';
export const PILOT_ROLE = 'pilot';
